module.exports = __webpack_public_path__ + "img/组件8.b0fd8189.png";